// Focused presentations of existing editors. Their hooks own validation and mutations.
function SuperPlummaInvoiceSurface({ control }) {
  const s = useInvoice();
  const [mode, setMode] = useState('onepage');
  const [issued, setIssued] = useState(null);
  useInvoiceControlEditor(s, { mode, setMode, setStep: () => {}, setShowPreview: () => {}, blocked: Boolean(issued), onIssued: setIssued });
  return <div className="spw-document">
    <div className="spw-document-heading" data-assistant-exclude="true"><span>{t('spw.invoice')}</span><Button size="sm" variant="secondary" disabled={control.state.busy || Boolean(issued)} onClick={() => control.session.save()}>{t('spw.saveDraft')}</Button></div>
    {issued && <p role="status">{t('spw.issued')}</p>}
    <InvoicePreview s={s}/>
  </div>;
}

function SuperPlummaPurchaseSurface({ receipt, onReceipt, control }) {
  const [localReceipt, setLocalReceipt] = useState(() => receipt || window.PlummePurchaseRoutedReceipt.consume('nyttkjop'));
  const [purchaseType, setPurchaseType] = useState('Vanlig kjøp');
  const [editing, setEditing] = useState(false);
  const [saved, setSaved] = useState(null);
  const setReceipt = value => { setLocalReceipt(value); onReceipt(value); };
  useEffect(() => {
    const attach = event => { if (event.detail) { window.__plummeRouteReceipt = null; setReceipt(event.detail); } };
    window.addEventListener('plumme-route-receipt', attach);
    return () => window.removeEventListener('plumme-route-receipt', attach);
  }, []);
  return <div className="spw-document">
    <div className="spw-document-heading"><span>{t('spw.receipts')}</span><Button size="sm" variant="ghost" disabled={control.state.busy} onClick={() => setEditing(value => !value)}>{t(editing ? 'spw.showProposal' : 'spw.editDetails')}</Button></div>
    {localReceipt && <BackendReceiptPreview receipt={localReceipt} big/>}
    {!localReceipt && <div className="spw-empty-document"><Icon name="files" size={32}/><p>{t('spw.addReceipt')}</p></div>}
    <PurchaseForm receipt={localReceipt} onReceipt={setReceipt} kjopType={purchaseType} onKjopTypeChange={setPurchaseType} editExpense={saved} onSaved={setSaved}
      renderSummary={editing ? undefined : model => <SuperPlummaPurchaseProposal model={model} busy={control.state.busy} onEdit={() => setEditing(true)}/>}/>
  </div>;
}

function SuperPlummaPurchaseProposal({ model, busy, onEdit }) {
  const lines = model.lines.filter(line => String(line.desc || '').trim() || Number(line.net));
  return <div className="spw-proposal">
    <h2>{t('spw.proposal')}</h2>
    <p className="muted">{model.supplierName || t('spw.supplierMissing')} · {PlummeI18n.date(model.date)}</p>
    {lines.length ? <div className="spw-proposal-lines">{lines.map(line => <div key={line.id}>
      <div><b>{line.desc}</b><div className="muted t-sm">{t('spw.account')} {line.costAccountCode || t('spw.notSelected')} · {line.reverse === '86' ? t('buy.vatChoice.reverse86') : `${t('spw.vat')} ${PlummeI18n.number(line.vat)}%`}</div></div><span>{fmtDec(line.net)}</span>
    </div>)}</div> : <p role="status" className="muted">{t('spw.readingHint')}</p>}
    {lines.length > 0 && <MathSummary net={model.net} vat={model.vat}/>}
    <p className="t-sm muted">{t('spw.paymentAccount')}: {model.isPaid ? (model.payAcct || t('spw.notSelected')) : t('spw.unpaid')}</p>
    {model.receiptNeedsReview && <p role="status">{t('purchaseFlow.amountReview')}</p>}
    {model.editLock && <p role="alert">{model.editLock.text}</p>}
    {model.error && <p role="alert" className="invoice-control-error">{model.error}</p>}
    <div className="row wrap gap-8"><Button variant="secondary" size="sm" disabled={busy || model.saving || Boolean(model.editLock)} onClick={model.saveDraft}>{t('spw.saveDraft')}</Button><Button variant="ghost" size="sm" disabled={busy || model.saving} onClick={onEdit}>{t('spw.editDetails')}</Button></div>
    <p className="muted t-xs">{t('spw.approvalHint')}</p>
  </div>;
}

// Less common tasks keep their established editor, opened on demand in a dialog.
function SuperPlummaTaskDialog({ route, year, control }) {
  const [open, setOpen] = useState(true);
  useEffect(() => { setOpen(true); }, [route]);
  const Component = window[window.PLUMME_ROUTE_COMPONENTS[route]];
  return <div className="spw-empty-document"><Button variant="secondary" onClick={() => setOpen(true)}>{t('spw.openTask')}</Button>
    {open && <Modal open max={1100} title={t(route === 'innboks' ? 'spw.receipts' : 'spw.sale')} onClose={() => { control.session.stop(); setOpen(false); }}><Component route={route} year={year} setRoute={control.workspace.navigate}/></Modal>}
  </div>;
}
Object.assign(window, { SuperPlummaInvoiceSurface, SuperPlummaPurchaseSurface, SuperPlummaTaskDialog });
